import { useParams } from "react-router-dom";

import { useFragment } from "@apollo/client";

import { type ResourceContainer, ResourceKind } from "../../gql-generated/types";
import { resourceContainer } from "../api/fragments";

export const useSelectedOrganization = (): ResourceContainer | null => {
    const { orgId } = useParams<{ orgId?: string }>();
    // kind is part of cache key to distinguish orgs from child resources (CameraKits) that share the same id
    const { data, complete } = useFragment<ResourceContainer>({
        fragment: resourceContainer,
        fragmentName: "ResourceContainerAll",
        from: {
            __typename: "ResourceContainer",
            id: orgId ?? "",
            kind: ResourceKind.Organizations,
        },
    });

    return complete ? data : null;
};
